import { useEffect } from 'react';
import { useParams, useOutletContext } from 'react-router-dom';
import { SendMessage } from 'react-use-websocket';
import { TransactionWarnings } from '@ui/src';
import { useAppSelector, useAppDispatch } from '@store';
import {
  setBlacklistData,
  setBlacklistDataVisible,
  setBlacklistDataItem,
  setBlacklistItemVisible,
  changePanelState,
} from '../../../store/slices/problem-transactions/incoming-transaction';
import useProblemIncomingTransaction from '../hooks/use-incoming';

const IncomingTransactionWarning = (): React.JSX.Element => {
  const { warnings, transaction, chats, recipientAccounts } = useAppSelector(
    (state) => state.customersProblemTransactions.incoming,
  );
  const { customersTransactionTypes, currentEmployee } = useAppSelector(
    (state) => state.customersDictionaries,
  );
  const { currencies: currenciesList } = useAppSelector((state) => state.root);

  const dispatch = useAppDispatch();

  const { sendMessage } = useOutletContext<{
    sendMessage: SendMessage | null;
  }>();

  const { transactionId } = useParams();

  const {
    getRecipientAccounts,
    chatCreateInProgress,
    createChatWithMessage,
    getIncomingTransactionWarningByIdAction,
    isWarningByIdLoading,
    isWarningByIdFetching,
  } = useProblemIncomingTransaction({
    transactionId,
    sendMessage,
    currenciesList,
    currentEmployee,
  });

  useEffect(() => {
    if (
      transaction &&
      transaction.recipientAccount &&
      transaction.recipientAccount?.organization?.type === 'CORPORATE' &&
      !recipientAccounts
    ) {
      getRecipientAccounts(transaction.recipientAccount.organizationId);
    }
  }, [transaction, recipientAccounts]);

  return (
    <TransactionWarnings
      warnings={warnings}
      employee={undefined}
      transactionsTypes={customersTransactionTypes}
      setBlacklistDataVisible={(visible) => {
        dispatch(setBlacklistDataVisible(visible));
        dispatch(changePanelState({ state: false }));
      }}
      setBlacklistData={(data) => dispatch(setBlacklistData(data))}
      setBlacklistItemVisible={(visible) => {
        dispatch(setBlacklistItemVisible(visible));
        dispatch(changePanelState({ state: false }));
      }}
      setBlacklistDataItem={(data) => dispatch(setBlacklistDataItem(data))}
      transactionUrlType="incoming"
      transactionId={transactionId}
      companyOfficials={recipientAccounts}
      individualCustomer={transaction?.recipientAccount}
      chats={chats}
      createChatWithMessage={createChatWithMessage}
      chatCreateInProgress={chatCreateInProgress}
      getWarningById={getIncomingTransactionWarningByIdAction}
      isWarningByIdLoading={isWarningByIdLoading}
      isWarningByIdFetching={isWarningByIdFetching}
      withTransactionUrl
    />
  );
};

export default IncomingTransactionWarning;
